import store from '../store'

export default async (to, from, next) => {
    if (store.getters['auth/role'] !== 'root') {
        next({name: 'Home'})
    } else {
        next()
    }
}
